<template>
    <div
        :class="['p-checkbox p-component ' + (small ? '' : 'checkbox-big'), {'p-checkbox-focused': focused, 'p-disabled': $attrs.disabled}]"
        @click="onClick"
        @mouseleave="$refs.box.blur()"
        @keydown.space.prevent="onClick">

        <v-tooltip-wrapper :open-delay="650"
                           :open-on-click="false"
                           tooltip-position="right">
            <template #activator="{ on, attrs }">

                <div ref="box"
                     :aria-checked="checked"
                     :class="['p-checkbox-box p-component', {
                         'p-highlight': checked,
                         'checkbox-indeterminate': indeterminate,
                         'p-disabled': $attrs.disabled,
                         'p-focus': focused
                     }]"
                     :tabindex="$attrs.disabled ? null : '0'"
                     role="checkbox"
                     v-bind="attrs"
                     @blur="onBlur($event)"
                     @focus="onFocus($event)"
                     v-on="on">

                    <span
                        :class="['p-checkbox-icon far', {'p-checkbox-icon-visible': checked || indeterminate}, indeterminate ? 'fa-minus' : 'fa-check']" />
                </div>
            </template>
            <span>{{ checked ? deselectMessage : selectMessage }}</span>
        </v-tooltip-wrapper>
    </div>
</template>

<script>
import VTooltipWrapper from '../../../common/v-tooltip-wrapper.vue'

export default {
    name: 'tristate-checkbox',
    components: { VTooltipWrapper },
    inheritAttrs: false,
    props: {
        checked: null,
        indeterminate: null,
        small: Boolean,
        selectMessage: {
            type: String,
            default: Lang.langGet('Select all')
        },
        deselectMessage: {
            type: String,
            default: Lang.langGet('Clear selection')
        }
    },
    data() {
        return {
            focused: false,
        }
    },
    methods: {
        onClick(event) {
            if (!this.$attrs.disabled) {
                this.focused = true
                this.$emit('change', {
                    originalEvent: event,
                    checked: !this.checked
                })
            }
        },
        onFocus() {
            this.focused = true
        },
        onBlur() {
            this.focused = false
        }
    }
}
</script>
